import { BASE_URL, JOBS_BY_DEPARTMENTS, PUBLIC } from "../../common/URLs";

const API_BASE_URL = `${BASE_URL}/${PUBLIC}/${JOBS_BY_DEPARTMENTS}`; 

export const fetchPopularJobCategoriesList = async (uuid) => {
  const url = `${API_BASE_URL}/${uuid}`; 
  // console.log("url", url)
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    // console.log("response", response)
    const data = await response.json();
    return data;
  } catch (error) {
    // console.log("error", error);
    const errorMessage = error.message;
  }
};